import Vue from 'vue'
import Router from 'vue-router'
import jwt from 'jsonwebtoken'
import store from './store/index'

const PUBLIC_KEY_JWT = (process.env.VUE_APP_PUBLIC_KEY_JWT || '').replace(/\\n/g, '\n')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/Index'),
    },
    {
      path: '/monitor/:id',
      name: 'Monitoramento',
      component: () => import('@/views/monitor/Index'),
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          name: 'Usuários',
          path: '/users',
          component: () => import('@/views/dashboard/listUsers'),
        },
        {
          name: 'Arquivos AWS',
          path: '/backup/files',
          component: () => import('@/views/dashboard/awsFiles'),
        },
        {
          name: 'Servidores AWS',
          path: '/aws-servers',
          component: () => import('@/views/dashboard/awsServers'),
        },
        {
          name: 'Atualizacoes',
          path: '/atualizacoes',
          component: () => import('@/views/dashboard/atualizacoes'),
        },
        {
          name: 'Clientes com serviço WEB',
          path: '/list-customer',
          component: () => import('@/views/dashboard/listCustomers'),
        },
        {
          name: 'Clientes CLINIC',
          path: '/list-clinic-customers',
          component: () => import('@/views/dashboard/listClinicCustomers'),
        },
        {
          name: 'Configuração de servidores',
          path: '/config-servers',
          component: () => import('@/views/dashboard/configServers'),
        },
        {
          name: 'Executaveis',
          path: '/exec',
          component: () => import('@/views/dashboard/Executables'),
        },
        {
          name: 'Perguntas Frequentes',
          path: '/faq',
          component: () => import('@/views/dashboard/FAQ'),
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/monitor/:id']
  const authRequired = !publicPages.includes(to.matched[0].path)
  const user = JSON.parse(localStorage.getItem('user'))
  let loggedIn = 0
  if (user) {
    const userToken = user.access_token

    try {
      await jwt.verify(userToken, PUBLIC_KEY_JWT, { algorithms: ['RS256'] })
      loggedIn = 1
    } catch (err) {
      console.error(err)
      loggedIn = 0
    }
  }

  if (authRequired && !loggedIn) {
    console.error('Access Forbidden!')
    store.commit('account/CHANGE_DESTINATION', to.fullPath)
    return next('/login')
  }
  next()
})

export default router
